module.exports = __webpack_public_path__ + "img/i-roleplay.2c69d341.svg";